export default function (Component) {
Component.options.__docs = "<p>By default you can only select a single date. To change that simply set the <code>selectionMode</code> to &#39;range&#39;.</p>\n"
}